 import api from "../../api.js";

 export const getCompany = async () => {
   const res = await api.get("/api/company");
   return res.data;
 };

 export const saveCompany = async (payload) => {
   const res = await api.put("/api/company", payload);
   return res.data;
 };

